import styled from '@emotion/styled';

export const AreaLocationContainer = styled.div`
	width: 100%;
	.text-area {
		max-width: 100%;
		min-width: 50%;
		max-height: 30rem;
		min-height: 4.5rem;
	}
`;

export const FormArea = styled.div`
	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	width: 100%;
	padding: var(--padding-2);
	gap: 1rem;
`;

export const FlagOptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	padding: 0 0.5rem;
	&.selected {
		gap: 0.5rem;
	}
`;
